import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';
import esTranslation from './locales/es/translation.json';
import arTranslation from './locales/ar/translation.json';
import trTranslation from './locales/tr/translation.json';
import elTranslation from './locales/el/translation.json';
import itTranslation from './locales/it/translation.json';
import ptTranslation from './locales/pt/translation.json';
import hrTranslation from './locales/hr/translation.json';
import sqTranslation from './locales/sq/translation.json';
import mtTranslation from './locales/mt/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  fr: {
    translation: frTranslation
  },
  es: {
    translation: esTranslation
  },
  ar: {
    translation: arTranslation
  },
  tr: {
    translation: trTranslation
  },
  el: {
    translation: elTranslation
  },
  it: {
    translation: itTranslation
  },
  pt: {
    translation: ptTranslation
  },
  hr: {
    translation: hrTranslation
  },
  sq: {
    translation: sqTranslation
  },
  mt: {
    translation: mtTranslation
  }
};

const supportedLngs = ['en', 'fr', 'es', 'ar', 'tr', 'el', 'it', 'pt', 'hr', 'sq', 'mt'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs,
    fallbackLng: 'en',
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    debug: false,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;




